"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const classnames_1 = __importDefault(require("classnames"));
const constructBreakpointsClasses = (breakpoints) => {
    const keys = Object.keys(breakpoints);
    const classes = keys.reduce((previousClass, key) => {
        const breakpoint = key === 'xs' ? '' : `-${key}`;
        const breakpointValue = breakpoints[key];
        if (breakpointValue) {
            if (typeof breakpointValue === 'number') {
                return (0, classnames_1.default)(previousClass, `hot-col${breakpoint}-${breakpointValue}`);
            }
            const { size, offset, order } = breakpointValue;
            return (0, classnames_1.default)(previousClass, `hot-col${breakpoint}-${size}`, {
                [`hot-col${breakpoint}-offset-${offset}`]: offset,
                [`hot-col${breakpoint}-order-${order}`]: order
            });
        }
        return previousClass;
    }, '');
    return classes || 'hot-col';
};
const Col = ({ children, xs, sm, md, lg, xl, xxl, className, 'data-test': dataTest }) => {
    const breakpoints = { xs, sm, md, lg, xl, xxl };
    const breakpointClasses = constructBreakpointsClasses(breakpoints);
    const classes = (0, classnames_1.default)(breakpointClasses, className);
    return ((0, jsx_runtime_1.jsx)("div", { "data-test": dataTest, className: classes, children: children }));
};
exports.default = Col;
